var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn-dropdown",
    { attrs: { icon: "add", flat: "", dense: "" } },
    [
      _c(
        "q-list",
        {
          style: { "min-width": "180px" },
          attrs: { "no-border": "", link: "" }
        },
        [
          _c("q-list-header", [_vm._v(_vm._s(_vm.$tc("invoice", 2)))]),
          _c(
            "q-item",
            {
              attrs: {
                item: "",
                to: { name: "create-invoice", params: { teamId: _vm.teamId } }
              }
            },
            [
              _c("q-item-main", {
                attrs: { label: _vm.$t("quick_create.new_invoice") }
              })
            ],
            1
          ),
          _c(
            "q-item",
            {
              attrs: {
                item: "",
                to: { name: "create-quote", params: { teamId: _vm.teamId } }
              }
            },
            [
              _c("q-item-main", {
                attrs: { label: _vm.$t("quick_create.new_quote") }
              })
            ],
            1
          ),
          _c("q-item-separator"),
          _c("q-list-header", [_vm._v(_vm._s(_vm.$tc("customer", 2)))]),
          _c(
            "q-item",
            {
              attrs: {
                item: "",
                to: { name: "create-person", params: { teamId: _vm.teamId } }
              }
            },
            [
              _c("q-item-main", {
                attrs: { label: _vm.$t("quick_create.new_person") }
              })
            ],
            1
          ),
          _c(
            "q-item",
            {
              attrs: {
                item: "",
                to: { name: "create-company", params: { teamId: _vm.teamId } }
              }
            },
            [
              _c("q-item-main", {
                attrs: { label: _vm.$t("quick_create.new_company") }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }